import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Security, SecureRoute } from '@okta/okta-react';
import Footer from '../Footer';
import Header from '../Header';
import HtmlHelpers from '../HtmlHelpers';
import WmAuthCallback from '../WmAuthCallback';
const config = {
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  issuer: process.env.REACT_APP_OKTA_URL,
  redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URL
};
const pageStyle = {
  padding: '0px 20px 0px 20px'
};
export default class AppJs extends Component {
  constructor(_props) {
    super(_props);
    this.setUserInfo = userInfo => {
      this.setState({
        userName: HtmlHelpers.getUser(),
        userInfo
      });
    };
    this.defaultRoute = () => '';
    this.routes = () => [];
    this.buildRoutes = () => {
      const DefaultContainer = this.defaultRoute();
      return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
        path: "/implicit/callback",
        component: WmAuthCallback
      }), this.routes().map(route => {
        const RouteContainer = route.component;
        return /*#__PURE__*/React.createElement(SecureRoute, {
          key: route.path,
          exact: true,
          path: route.path,
          render: props => {
            const allProps = {
              ...props,
              ...route.props
            };
            return /*#__PURE__*/React.createElement(RouteContainer, Object.assign({
              setUserInfo: this.setUserInfo
            }, allProps));
          }
        });
      }), /*#__PURE__*/React.createElement(SecureRoute, {
        default: true,
        render: props => /*#__PURE__*/React.createElement(DefaultContainer, Object.assign({
          setUserInfo: this.setUserInfo
        }, props))
      }));
    };
    this.state = {
      userName: HtmlHelpers.getUser()
    };
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "App"
    }, /*#__PURE__*/React.createElement(BrowserRouter, {
      basename: process.env.REACT_APP_BASENAME
    }, /*#__PURE__*/React.createElement(Security, {
      issuer: config.issuer,
      client_id: config.clientId,
      redirect_uri: config.redirectUri
    }, /*#__PURE__*/React.createElement(Header, {
      name: this.state.userName,
      userInfo: this.state.userInfo,
      app_env: process.env.REACT_APP_TITLE_ENV
    }), /*#__PURE__*/React.createElement("div", {
      style: pageStyle
    }, this.buildRoutes()), /*#__PURE__*/React.createElement(Footer, null))));
  }
}